import { Controller } from "@hotwired/stimulus"

// Kopiert den Wert des Ziels source (z. B. die iCal-Adresse) und zeigt am
// Button kurz die Bestätigung (data-clipboard-success-value).
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { success: { type: String, default: "Kopiert" }, duration: { type: Number, default: 2000 } }

  async copy(event) {
    event?.preventDefault()
    const text = "value" in this.sourceTarget ? this.sourceTarget.value : this.sourceTarget.textContent
    await navigator.clipboard.writeText(text.trim())
    this.confirm()
  }

  confirm() {
    if (!this.hasButtonTarget) return

    const button = this.buttonTarget
    this.originalLabel ??= button.textContent
    button.textContent = this.successValue
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      button.textContent = this.originalLabel
    }, this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timer)
    if (this.hasButtonTarget && this.originalLabel != null) this.buttonTarget.textContent = this.originalLabel
  }
}
